module.exports = __webpack_public_path__ + "img/settings_backup_restore.e02bc955.svg";